/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import TextInputCellEditor from '../TextInputCellEditor';

import tmplDateInputCellEditorView from './DateInputCellEditorView.hbs';

const DollarInputCellEditorView = TextInputCellEditor.extend({
  tagName: 'div',

  className: 'date-input-cell-editor-view',

  template: tmplDateInputCellEditorView,

  ui: {
    input: 'input',
  },

  events: {
    'keydown @ui.input': 'saveOrCancel',
    'change @ui.input': 'saveOrCancel',
  },

  templateContext() {
    return {
      placeholder: this.placeholder,
      modelId: this.model.cid,
      columnName: this.column.get('name'),
    };
  },

  onRender() {
    const model = this.model;
    this.datepicker = this.ui.input.datepicker();
    const formattedValue = this.formatter.fromRaw(model.get(this.column.get('name')), model);
    this.ui.input.val(formattedValue);

    this.datepicker.on('hide', (e) => {
      e.type = 'change';
      this.saveOrCancel(e);
    });
  },

  getValue() {
    return this.ui.input.val();
  },
});

export default DollarInputCellEditorView;
